import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ChangePassword from '../../components/templates/Login/changePassword';

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

/**
 * ログイン画面:パスワード変更 ページ。
 * 画面ID:SCZ1001
 */
class App extends React.Component {
  async componentDidMount() {
    window.scrollTo(0, 0);
  }

  /**
   * 画面描画。
   *
   * @return {JSX.Element} 描画要素
   */
  render() {
    return <ChangePassword />;
  }
}

const ContainerApp = connect(
    mapStateToProps,
    mapDispatchToProps,
)(App);

App.propTypes = {
};

export default ContainerApp;
